import { gql } from '@apollo/client';

import {
  APPOINTMENT_DATE_FRAGMENT,
  APPOINTMENT_NOTE_FRAGMENT,
  APPOINTMENT_FILE_FRAGMENT
} from './fragments';

export const OPEN_ROOM = gql`
  mutation OpenRoom($input: AppointmentIdInput!) {
    openRoom(input: $input) {
      data {
        meetUrl
        redirect_url
      }
    }
  }
`;

export const APPROVE_DATE = gql`
  mutation ApproveDate($appointmentId: ID!, $dateId: ID!) {
    approveDate(appointment: $appointmentId, id: $dateId) {
      data {
        status
      }
      message
    }
  }
`;

export const REQUEST_APPOINTMENT_DATES = gql`
  mutation RequestAppointmentDates($id: ID!, $input: AppointmentDateInput!) {
    requestAppointmentDates(id: $id, input: $input) {
      data {
        ...AppointmentDateFragment
      }
    }
  }
  ${APPOINTMENT_DATE_FRAGMENT}
`;

export const CREATE_APPOINTMENT_NOTE = gql`
  mutation CreateAppointmentNote($id: ID!, $input: AppointmentNoteInput!) {
    createAppointmentNote(id: $id, input: $input) {
      data {
        ...AppointmentNoteFragment
      }
    }
  }
  ${APPOINTMENT_NOTE_FRAGMENT}
`;

export const CREATE_APPOINTMENT_FILE = gql`
  mutation CreateAppointmentFile($id: ID!, $input: AppointmentFileInput!) {
    createAppointmentFile(id: $id, input: $input) {
      data {
        ...AppointmentFileFragment
      }
    }
  }
  ${APPOINTMENT_FILE_FRAGMENT}
`;

export const REJECT_APPOINTMENT = gql`
  mutation RejectStatus($id: ID!, $input: RejectStatusInput) {
    rejectStatus(id: $id, input: $input) {
      message
    }
  }
`;

export const UPDATE_APPOINTMENT_STATUS = gql`
  mutation UpdateAppointmentStatus($id: ID!, $input: UpdateStatusInput) {
    updateAppointmentStatus(id: $id, input: $input) {
      data {
        status
      }
    }
  }
`;

export const TRANSLATE = gql`
  mutation Mutation($input: TranslateInput) {
    translate(input: $input) {
      data {
        body
      }
    }
  }
`;

export const CREATE_INVOICE = gql`
  mutation AppointmentInvoice($input: AppointmentInvoiceInput!) {
    appointmentInvoice(input: $input) {
      message
    }
  }
`;

export const CREATE_DOCTOR_APPOINTMENT = gql`
  mutation CreateAppointmentByDoctor($input: AppointmentSessionPayInput) {
    createAppointmentByDoctor(input: $input) {
      data {
        id
      }
      message
    }
  }
`;

export const DELETE_APPOINTMENT = gql`
  mutation DeleteAppointment($id: ID!) {
    deleteAppointment(id: $id) {
      message
    }
  }
`;
